import { Svg, Path, G, Defs, ClipPath, Rect } from "react-native-svg";
import { SvgProps } from "react-native-svg";

const AwardIcon = (props: SvgProps) => (
  <Svg {...props} width="22" height="23" viewBox="0 0 22 23" fill="none">
    <G id="award" clipPath="url(#clip0_44151_2217)">
      <Path
        id="Vector"
        d="M7.52583 13.1684L6.41666 21.5192L11 18.7692L15.5833 21.5192L14.4742 13.1592M17.4167 7.76921C17.4167 11.313 14.5438 14.1859 11 14.1859C7.45617 14.1859 4.58333 11.313 4.58333 7.76921C4.58333 4.22538 7.45617 1.35254 11 1.35254C14.5438 1.35254 17.4167 4.22538 17.4167 7.76921Z"
        stroke="#090A0A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_44151_2217">
        <Rect width="22" height="22" fill="white" transform="translate(0 0.436035)" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default AwardIcon;
